var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isStartedJob
    ? _c(
        "div",
        { staticClass: "workflow-container d-flex flex-column flex-fill" },
        [
          _c("div", { staticClass: "row flex-grow-1" }, [
            _c("div", { staticClass: "col" }, [
              _c(
                "div",
                {
                  staticClass: "loading-container",
                  class: [_vm.isWaitingJob ? "d-flex" : "d-none"],
                },
                [
                  _c("div", { staticClass: "loading small" }, [
                    _c("img", { attrs: { src: _vm.loadingIcon, alt: "" } }),
                    _vm._v(" "),
                    _c("span", { staticClass: "font-weight-bold" }, [
                      _vm._v(_vm._s(_vm.$t(`global.workflow.waiting`))),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "panel-holder" }, [
                _c("div", { staticClass: "view-container" }, [
                  _c(
                    "div",
                    {
                      class: [_vm.isExecutingJob ? "d-block" : "d-none"],
                      attrs: { id: "divPlantsWithoutUrls" },
                    },
                    [
                      _c("div", { staticClass: "innerDetails" }, [
                        _c("div", { staticClass: "loading small mb-3" }, [
                          _c("img", {
                            attrs: { src: _vm.loadingIcon, alt: "" },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "font-weight-bold" }, [
                            _vm._v(_vm._s(_vm.currentProgressJob.msg)),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "ul",
                          { staticClass: "list-group list-group-flush" },
                          _vm._l(_vm.progressJob, function (progress, idx) {
                            return _c(
                              "li",
                              {
                                key: `progress-${idx}`,
                                staticClass:
                                  "list-group-item px-0 text-muted small",
                                class: [
                                  progress.status == "ok" ? "" : "txt-error",
                                ],
                              },
                              [
                                _c("span", {}, [
                                  _c("i", {
                                    staticClass: "fas",
                                    class: [
                                      progress.status == "ok"
                                        ? "fa-check"
                                        : "fa-times",
                                    ],
                                  }),
                                ]),
                                _vm._v(" "),
                                _c("span", {
                                  domProps: { innerHTML: _vm._s(progress.msg) },
                                }),
                              ]
                            )
                          }),
                          0
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      class: [_vm.isCompletedJob ? "d-block" : "d-none"],
                      attrs: { id: "divPlantsUrls" },
                    },
                    [
                      _vm._t(
                        "completedJob",
                        function () {
                          return [
                            _vm.hasValidResult
                              ? _c("div", { staticClass: "innerDetails" }, [
                                  _c("p", {
                                    domProps: {
                                      innerHTML: _vm._s(_vm.resultDescription),
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "ul",
                                    {
                                      staticClass:
                                        "group-plant-list list-unstyled",
                                    },
                                    [
                                      _c("li", [
                                        _vm.hasIndividualDocsJob
                                          ? _c("div", [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(_vm.$t(_vm.titleList))
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "ul",
                                                {
                                                  staticClass:
                                                    "list-plant mb-3",
                                                },
                                                _vm._l(
                                                  _vm.individualDocsJob,
                                                  function (doc, idx) {
                                                    return _c(
                                                      "li",
                                                      {
                                                        key: idx,
                                                        staticClass:
                                                          "item-plant",
                                                      },
                                                      [
                                                        _c(
                                                          "a",
                                                          {
                                                            attrs: {
                                                              target: "_blank",
                                                              href: doc.url,
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                                        " +
                                                                _vm._s(
                                                                  doc.label
                                                                ) +
                                                                "\n                                                    "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                0
                                              ),
                                            ])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.hasGlobalDocJob
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "uniqueDocsContainer",
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        `global.workflow.result.global.title`
                                                      )
                                                    )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "ul",
                                                  {
                                                    staticClass: "list-unique",
                                                  },
                                                  [
                                                    _c(
                                                      "li",
                                                      {
                                                        staticClass:
                                                          "item-unique",
                                                      },
                                                      [
                                                        _c(
                                                          "a",
                                                          {
                                                            attrs: {
                                                              target: "_blank",
                                                              href: _vm
                                                                .globalDocJob
                                                                .url,
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                                        " +
                                                                _vm._s(
                                                                  _vm
                                                                    .globalDocJob
                                                                    .label
                                                                ) +
                                                                "\n                                                    "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.hasReport
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "uniqueReportContainer",
                                              },
                                              [
                                                _vm.titleList
                                                  ? _c(
                                                      "p",
                                                      { staticClass: "mb-2" },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              _vm.titleList
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm._t("report", null, {
                                                  data: _vm.reportJob,
                                                }),
                                              ],
                                              2
                                            )
                                          : _vm._e(),
                                      ]),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.isValidResult
                              ? _c(
                                  "div",
                                  { attrs: { id: "noOutput" } },
                                  [
                                    _vm.isFailedJob
                                      ? [
                                          _c(
                                            "p",
                                            { staticClass: "txt-error" },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    _vm.$t(_vm.errorResult)
                                                  ) +
                                                  "\n                                    "
                                              ),
                                            ]
                                          ),
                                        ]
                                      : _vm.hasErrors
                                      ? [
                                          _c("p", [
                                            _vm._v(
                                              _vm._s(_vm.$t(_vm.titleErrors))
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "ul",
                                            { staticClass: "list-errors mt-3" },
                                            _vm._l(
                                              _vm.errorsJob,
                                              function (error, idx) {
                                                return _c(
                                                  "li",
                                                  {
                                                    key: idx,
                                                    staticClass: "item-error",
                                                  },
                                                  [
                                                    _c("span", {
                                                      staticClass: "txt-error",
                                                      domProps: {
                                                        innerHTML:
                                                          _vm._s(error),
                                                      },
                                                    }),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                        ]
                                      : [
                                          _c("div", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.$t(_vm.emptyResult)
                                              ),
                                            },
                                          }),
                                        ],
                                  ],
                                  2
                                )
                              : _vm._e(),
                          ]
                        },
                        {
                          dataJob: _vm.dataJob,
                          isFailedJob: _vm.isFailedJob,
                          titleList: _vm.titleList,
                          description: _vm.description,
                          emptyResult: _vm.emptyResult,
                          errorResult: _vm.errorResult,
                        }
                      ),
                    ],
                    2
                  ),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _vm.isCompletedJob
            ? _c(
                "div",
                {
                  staticClass: "btn-group responsive",
                  attrs: { role: "group" },
                },
                [
                  _vm._t("footer-prepend"),
                  _vm._v(" "),
                  _vm.showBtnClose
                    ? _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-main btn-rounded btn-sm btn-block",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.close.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.buttons["close"]) +
                              "\n        "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._t("footer-append"),
                ],
                2
              )
            : _vm._e(),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }